import { Box, Button } from "@mui/material";
import React from "react";
import styles from "../../../../styles/components/RejectionJustificationModal.module.scss";
import ModalWrapper from "../../../../ui/ModalWrapper/ModalWrapper";

const RejectionJustificationModal = ({ modalProps, headTitle }) => {
  const { open, onClose, note, setNote, setGoBack } = modalProps;

  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      handleClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.messageModal}>
        <Box className={styles.messageModalHeader}>
          <h4>{headTitle}</h4>
        </Box>

        <Box className={styles.messageModalBody}>
          <Box className={styles.messageInput}>
            <textarea onChange={(e) => setNote(e.target.value)}>
              {note}
            </textarea>
          </Box>
        </Box>

        <Box className={styles.messageModalFooter}>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setGoBack(true);
              onClose();
            }}
            className={styles.active}
          >
            Save
          </Button>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default RejectionJustificationModal;
